import { Component, OnInit, Input, Inject, ViewChild, Output, EventEmitter } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { LoaderService } from '../../shared/loader/loader.service';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-ai-runList',
  templateUrl: './ai-runList.component.html',
  styleUrls: ['./ai-runList.component.scss']
})

export class AIRunListComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  spinner: boolean = false;
  aiRunningList: any = [] = [];
  folderList: any = [] = [];
  showNoRecordFound: boolean = false;

  constructor(private dialog: MatDialog, private dialog1: MatDialog, private datePipe: DatePipe,
    public dialogRef: MatDialogRef<AIRunListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService, private loaderService: LoaderService,) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach((oe: any) => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }
  }

  ngOnInit(): void {
    this.getAllFolders();
  }


  // get all folders
  getAllFolders() {
    var reqModel = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      transactionID: Number(sessionStorage.getItem('transactionID'))
    }
    this.loaderService.show();
    this.settingsService.GetAllCoreDocumentPlaceholders(reqModel).subscribe((response: any) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.folderList = response.data;
          this.aiRunningList = [];
          this.showNoRecordFound=false;

          if (this.folderList?.length > 0) {
            this.aiRunningList = response.data.flatMap((folder: any) =>
              (folder.placeholders || [])
                .filter((placeholder: any) => placeholder.aiProcessStatus === 1)
                .map((placeholder: any) => ({
                  ...placeholder,
                  placeholderName: placeholder.placeholderName,
                  folderName: folder.documentFolderName,
                  folderId: folder.documentFolderID
                }))
            );

            if(this.aiRunningList.length==0){
               this.showNoRecordFound=true;
            }
          }

          this.loaderService.hide();
        } else {
          this.showNoRecordFound=false;
          this.aiRunningList = [];
          this.loaderService.hide();
        }
      } else {
         this.showNoRecordFound=false;
        this.aiRunningList = [];
        this.loaderService.hide();
      }
    });
  }

  // upload(item: any) {

  // }

  // details(item: any) {

  // }

  // download(item: any) {

  // }


}
